import React, { useState } from "react";
import { Box, Grid, IconButton, LinearProgress } from "@mui/material";
import { ReactComponent as BrandIcon } from "../../../assets/svg/signup/brand-logo.svg";
import { ReactComponent as NeedHelpButton } from "../../../assets/svg/signup/NeedHelpButton.svg";
import { FxButton } from "../../Action/FxButton";
import FxModalGeneric from "../../Utils/FxModalGeneric";
import { ReactComponent as LogoutIcons } from "../../../assets/svg/signup/header-right-icon.svg";
import { ReactComponent as PartnerBackIcon } from "../../../assets/svg/signup/partner-back-button.svg";
import { useHistory } from "react-router-dom";
import { ContactUsModal } from "../Auth/ContactUsModal";
import { setLocalStorage } from "../../../libs/utils/cacheHandler";
import { getKey } from "../../../libs/utils/storageManager";
import {
  useIsMobileOrTabletScreen,
  useIsMobileScreen,
} from "../../../libs/utils/utils";
import { FxLink } from "../../Action/FxLink";
/**
 * Author : Shivaraj PP
 * Component : ProgressBar
 * Description : Header Layout used in signup and Onboarding pages
 */
interface HeaderProps {
  percentage: number;
  logoutIconRequired: boolean;
  customerType: any;
}
/**
 * **
 * ProgressBar Component
 * Displays a linear progress bar to indicate the completion status of the signup process
 *
 */
const ProgressBar: React.FC<{ percentage: number }> = ({ percentage }) => (
  <LinearProgress
    variant="determinate"
    value={percentage}
    className="header-progress-bar"
  />
);

/**
 * HelpButton Component
 * A reusable button component that displays "Need help?" text with an icon
 */
const HelpButton: React.FC<{ onClick: () => void }> = ({ onClick }) => (
  <FxButton
    className="help-button"
    variant="outlined"
    startIcon={<NeedHelpButton />}
    onClick={onClick}
  >
    Need help ?
  </FxButton>
);
export const HeaderSignup: React.FC<HeaderProps> = React.memo(
  ({ percentage, logoutIconRequired, customerType }) => {
    const isMobileScreen = useIsMobileOrTabletScreen();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const history = useHistory();
    /**
     * Function handle close modal
     */
    const handleExportModalClose = () => {
      setIsModalOpen(false);
    };
    /**
     * Function handle open modal
     */
    const handleExportModalOpen = () => {
      setIsModalOpen(true);
    };
    /**
     * Function handle partner back
     */
    const handlePartnerBack = () => {
      setLocalStorage("signUpFlow", false);
      setLocalStorage("kycRedirectionRoute", undefined);
      history.push("/leads-home");
    };
    return (
      <>
        <Grid xs={12} item  className="header-signup-wrapper">
          <Grid xs={12} container className="header-signup" >
            {getKey("loginType") === "PARTNER" && (
              <Grid className="header-signup-partner-back-icon">
                <IconButton
                  className="fx-partner-back-button"
                  component="a"
                  id="menu-top-signout-button"
                  onClick={handlePartnerBack}
                  title={"Back"}
                  aria-label={"Back"}
                  size="large"
                >
                  <PartnerBackIcon />
                </IconButton>
              </Grid>
            )}
            {!isMobileScreen ? (
              <>
              <Grid item container xs justifyContent="space-between">
                <Grid className="header-signup-brand-icon">
                  <Box>
                    <BrandIcon />
                  </Box>
                </Grid>
                <Grid className="need-help-button">
                  <HelpButton onClick={handleExportModalOpen} />
                </Grid>
              </Grid>

                <div className="header-signup-logout-icon">
                  {logoutIconRequired && (
                    <IconButton
                      component="a"
                      className="fx-profile-icon fx-logout header-logout-icon"
                      id="menu-top-signout-button"
                      onClick={() => history.push("/logout")}
                      title={"Logout"}
                      aria-label={"Logout"}
                      size="large"
                    >
                      {" "}
                      <LogoutIcons />
                    </IconButton>
                  )}
                </div>
              </>
            ) : (
              <Grid container  xs alignItems="center" justifyContent="space-between" pr={1}>
                <Grid xs item className="header-signup-brand-icon ">
                  {/* <PassportLogo /> */}
                  <BrandIcon  />
                </Grid>
                <Grid display="flex" justifyContent="space-between" gap={2}>
                  <Grid >
                    <FxLink className="header-signup-brand-icon-action"
                      onClick={handleExportModalOpen}
                    ><NeedHelpButton /></FxLink>
                  </Grid>
                  {logoutIconRequired && (
                    <Grid ><FxLink
                      component="a"
                      className="header-signup-brand-icon-action"
                      id="menu-top-signout-button"
                      onClick={() => history.push("/logout")}
                      title={"Logout"}
                      aria-label={"Logout"}
                    >
                      {" "}
                      <LogoutIcons />
                    </FxLink></Grid>
                  )}
                </Grid>
              </Grid>
            )}
          </Grid>
          <ProgressBar percentage={percentage} />
        </Grid>
        <FxModalGeneric
          id="trasaction-history-export-modal"
          open={isModalOpen}
          onClose={handleExportModalClose}
          componentProps={{ customerType: customerType }}
          className={"fx-modal-small2medium"}
          component={ContactUsModal}
        />
      </>
    );
  }
);
